import React from "react";

function DownloadPopup({ show, onClose, fileName, fileUrl, isCart, cartFileNames = [] }) {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white text-black p-6 rounded-lg w-96 shadow-2xl relative text-center">
        {/* Close button */}
        <button
          onClick={onClose}
          aria-label="Close"
          className="absolute top-2 right-2 text-red-600 font-bold text-2xl hover:text-red-800"
        >
          ×
        </button>

        <h2 className="text-xl font-bold mb-3">🎉 Purchase Successful!</h2>

        {isCart ? (
          <>
            <p className="mb-4 text-sm text-gray-700">
              Download each of your purchased bots below:
            </p>

            <ul className="space-y-2 text-left max-h-52 overflow-y-auto px-2">
              {cartFileNames.map((file, index) => (
                <li key={index}>
                  <a
                    href={`/downloads/${file}`}
                    download={file}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-blue-600 hover:bg-blue-500 text-white px-4 py-2 rounded inline-block"
                  >
                    ⬇️ Download {file}
                  </a>
                </li>
              ))}
            </ul>

            <p className="mt-4 text-xs text-gray-500">
              Files will also be available in your browser’s downloads folder.
            </p>
          </>
        ) : (
          <>
            <p className="mb-4 text-sm text-gray-700">
              Click the button below to download your bot:
            </p>

            <a
              href={fileUrl}
              download={fileName}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-blue-600 hover:bg-blue-500 text-white px-4 py-2 rounded inline-block"
            >
              ⬇️ Download {fileName}
            </a>

            {/* <p className="mt-4 text-xs text-gray-500">
              If the download doesn't start, ensure the file exists in <code>/public/downloads</code>.
            </p> */}
          </>
        )}
      </div>
    </div>
  );
}

export default DownloadPopup;
